/**
 * SmartInspect → Client Output → Client Communication.
 *
 * Lightweight contextual launcher only (mirrors SmartEvaluate). The single
 * source of truth for every email template lives at
 *   Platform → Email Templates  (/admin/email-templates)
 * This page explains which SmartInspect template exists and deep-links into
 * the shared editor.
 */
import { Link } from "react-router-dom";
import { Mail, ExternalLink } from "lucide-react";

export default function SmartInspectClientCommunicationPage() {
  return (
    <div className="space-y-5" data-testid="si-client-communication-page">
      <header>
        <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-[#025979]">
          SmartInspect · Client Output
        </p>
        <h1
          className="text-2xl font-bold text-[#111827] mt-1"
          style={{ fontFamily: "Chivo, sans-serif" }}
        >
          Client Communication
        </h1>
        <p className="text-sm text-[#6B7280] mt-1 max-w-2xl">
          Manage SmartInspect communication templates used for:
        </p>
        <ul className="text-sm text-[#374151] mt-2 list-disc list-inside space-y-0.5">
          <li>Executive ROI Business Case sharing</li>
        </ul>
        <p className="text-xs text-[#9CA3AF] mt-3 max-w-2xl">
          All templates live in the single shared editor — opening it here
          jumps you straight to the SmartInspect section.
        </p>
      </header>

      <section className="bg-white border border-[#E5E7EB] rounded-sm p-6 flex items-center justify-between">
        <div className="flex items-start gap-3">
          <Mail className="w-5 h-5 text-[#025979] mt-0.5" strokeWidth={1.5} />
          <div>
            <h2 className="text-sm font-semibold text-[#111827]">
              Manage Email Templates
            </h2>
            <p className="text-xs text-[#6B7280] mt-1 max-w-md">
              One shared template engine powers SmartEvaluate, SmartImprove and
              SmartInspect. Edits take effect immediately for future report sharing.
            </p>
          </div>
        </div>
        <Link
          to="/admin/email-templates#smartinspect"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-semibold rounded-sm border border-[#025979] text-[#025979] hover:bg-[#025979] hover:text-white transition-colors"
          data-testid="si-client-communication-open-shared"
        >
          Open Shared Email Templates <ExternalLink className="w-3.5 h-3.5" />
        </Link>
      </section>
    </div>
  );
}
